'use client';

import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useSearchParamsObject } from 'common-nextjs';
import { useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import { Button, Input } from 'ui';
import { qsStringify } from 'utils';

interface Props {}

const DesktopHeaderSearch: React.FC<Props> = () => {
  const urlQ = useSearchParamsObject<{ q?: string }>().q;
  const router = useRouter();

  const [search, setSearch] = useState(urlQ || '');

  useEffect(() => {
    setSearch(urlQ || '');
  }, [urlQ]);

  return (
    <form
      action="/search"
      className="relative mx-4 flex w-1/2"
      onSubmit={e => {
        e.preventDefault();
        router.push('/search' + qsStringify({ q: search }));
      }}
    >
      <Input
        type="search"
        name="q"
        className="flex-1 rounded-r-none"
        placeholder="Search for new and used gear"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      <Button className="rounded-l-none" type="submit">
        <MagnifyingGlassIcon className="h-5 w-5" />
      </Button>
    </form>
  );
};

export default DesktopHeaderSearch;
